import React, { useState } from "react";
import "../../../../../assets/styles/common/modal.scss";

import { formatTodayDate } from "../../../../../utils/judgingSheetUtils";
import JudgingSheetTemplate, {
  SHEET_WIDTH,
  SHEET_HEIGHT,
} from "./JudgingSheetTemplate";

import musicalityImg from "../../../../../assets/images/judgingSheet/musicality_Judging.png";
import performanceImg from "../../../../../assets/images/judgingSheet/performance_Judging.png";
import singingImg from "../../../../../assets/images/judgingSheet/singing_Judging.png";

const CATEGORY_IMAGES = [musicalityImg, performanceImg, singingImg];

const SAMPLE_ENTRY_CLASS_LABEL = "Entry Class";
const SAMPLE_GROUP_NAME = "Group Name";
const SAMPLE_JUDGE_NAME = "Judge Name";
const SAMPLE_NUMBER = 1;
const SAMPLE_SONG_LABEL = "Song 1";

// 画面に収まるよう、実寸(1836x2376px)を縮小して表示する倍率
const PREVIEW_SCALE = 0.25;

const JudgingSheetPreviewButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const dateStr = formatTodayDate();

  return (
    <>
      <button
        type="button"
        className="download-btn judging-sheet-download-btn"
        onClick={() => setIsOpen(true)}
        title="レイアウト確認用のサンプルをモーダルで表示"
      >
        見た目を確認
      </button>

      {isOpen && (
        <div className="modal-overlay" onClick={() => setIsOpen(false)}>
          <div
            className="modal-container judging-sheet-preview-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="modal-title">採点用紙 見た目確認</h2>

            <div className="judging-sheet-preview-panel">
              {CATEGORY_IMAGES.map((image) => (
                <div
                  className="judging-sheet-preview-frame"
                  key={image}
                  style={{
                    width: SHEET_WIDTH * PREVIEW_SCALE,
                    height: SHEET_HEIGHT * PREVIEW_SCALE,
                  }}
                >
                  <div
                    style={{
                      transform: `scale(${PREVIEW_SCALE})`,
                      transformOrigin: "top left",
                    }}
                  >
                    <JudgingSheetTemplate
                      imageSrc={image}
                      entryClassLabel={SAMPLE_ENTRY_CLASS_LABEL}
                      dateStr={dateStr}
                      entryNumber={SAMPLE_NUMBER}
                      judgeName={SAMPLE_JUDGE_NAME}
                      judgeNumber={SAMPLE_NUMBER}
                      groupName={SAMPLE_GROUP_NAME}
                      songLabel={SAMPLE_SONG_LABEL}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="modal-actions">
              <button
                type="button"
                className="cancel-button"
                onClick={() => setIsOpen(false)}
              >
                閉じる
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default JudgingSheetPreviewButton;
